import type { Patient } from '@cancercentrum/inca';
import { importSurveyApiV1 } from '../../utils/enkatregistret.ts';

export const addParticipantToUtskicksprojekt = async (utskicksprojektId2: number, patient: Patient): Promise<unknown> => {
    const { addParticipant } = await importSurveyApiV1();

    return addParticipant({
        patient,
        projectId: utskicksprojektId2,
    });
};
